import React from 'react';
import { observer } from 'src/utils/mobx-react';
import classNames from 'classnames';
import { pickMethodLabel } from 'src/components/CustomersBar/CustomerTab/BankingTab/BankingTab';
import { CurrencyType } from 'src_common/common/amount/website-money/currency';
import { Amount } from 'src_common/common/amount/Amount';
import { getCurrency } from 'src/AppState/sdk/staff';
import { DepositTransactionsType } from 'src/components/CustomersBar/CustomerTab/BankingTab/BankingTab.state';

type DepositHistoryPropsType = {
    depositTransactions: DepositTransactionsType | null;
    currency: CurrencyType;
};

export const DepositHistory = observer(
    'DepositHistory',
    ({ depositTransactions, currency }: DepositHistoryPropsType) => {
        const currencyType = getCurrency(currency);

        return (
            <table>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Payment</th>
                        <th>Amount</th>
                    </tr>
                </thead>

                {depositTransactions === null ? null : (
                    <>
                        <tbody>
                            {depositTransactions.data.map(({ id, finalized, amount, adjustmentType }) => (
                                <tr key={id}>
                                    <td>{finalized}</td>
                                    <td>{pickMethodLabel(adjustmentType)}</td>
                                    <td
                                        className={classNames({
                                            'amount--negative': amount.isLessThan(new Amount('0')),
                                        })}
                                    >
                                        {amount.format(currencyType)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th>Total</th>
                                <td>{depositTransactions.total.format(currencyType)}</td>
                            </tr>
                        </tfoot>
                    </>
                )}
            </table>
        );
    }
);
